import "./Timelines.scss";

const AudioTimeline = (): JSX.Element => {
    return (
        <div className="AudioTimeline">
            &nbsp;
            <div className="AudioTimeline__tracker">
                <div></div>
                <div></div>
            </div>
        </div>
    );
};

export default AudioTimeline;
